module.exports = __webpack_public_path__ + "static/kevin-close-min-ce9bc9a001128bebb0beb2a8ecd63de2.jpg";